import { render, staticRenderFns } from "./companyDetail.vue?vue&type=template&id=79c88a1e&scoped=true"
import script from "./companyDetail.vue?vue&type=script&lang=js"
export * from "./companyDetail.vue?vue&type=script&lang=js"
import style0 from "./companyDetail.vue?vue&type=style&index=0&id=79c88a1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c88a1e",
  null
  
)

export default component.exports